<!--Vista que muestra el panel de administración del administrador-->
<template>
  <v-container fluid class="px-0 pt-0">
    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->
        <v-row justify="center" class="pa-0 mb-5 pos-relative banner-container mx-0 mb-10">
          <v-img
            v-if="user.imgBackground && user.imgBackground!=''"
            :src="user.imgBackground"
            lazy-src="https://picsum.photos/id/11/10/6"
            class="banner-img"
          ></v-img>
          <div v-else class="banner-img" v-bind:style="organizerBackground"></div>
          <!--<v-col
            cols="12"
            sm="8"
            md="6"
            lg="6"
            xl="5"
            class="banner-content text-center white pa-5 pa-md-3 elevation-3"
          >
            <v-row justify="center" align="center" class="fill-height">
              <v-col cols="12" class="py-0">
                <v-avatar :size="($vuetify.breakpoint.xsOnly)?200:($vuetify.breakpoint.smOnly)?200:140">
                  <img :src="user.profilePicture" alt="avatar" />
                  <v-dialog v-model="profileDialog" persistent max-width="600px">
                    <template v-slot:activator="{ on }">
                      <v-btn absolute fab top right color="accent" small v-on="on">
                        <v-icon small>fas fa-pencil-alt</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Imagen de fondo</span>
                      </v-card-title>
                      <v-card-text class="pb-0">
                        <file-pond
                          name="event-img"
                          ref="pondProfile"
                          label-idle="Agrega una imagen de perfil..."
                          accepted-file-types="image/jpeg, image/png"
                        />
                      </v-card-text>
                      <v-card-actions class="pt-0">
                        <div class="flex-grow-1"></div>
                        <v-btn color="blue darken-1" text @click="profileDialog = false">Cerrar</v-btn>
                        <v-btn color="blue darken-1" text @click="processImgOrganizer()">Guardar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-avatar>
              </v-col>
              <v-col cols="12" class="py-0">
                <h1 class="display-2 font-weight-bold">{{ user.companyName}}</h1>
              </v-col>
            </v-row>
          </v-col>-->
          <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
                class="d-none d-flex"
                absolute
                fab
                bottom
                right
                color="accent"
                v-on="on"
              >
                <v-icon>fas fa-pencil-alt</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Imagen de fondo</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <file-pond
                  name="event-img"
                  ref="pondHeader"
                  label-idle="Agrega un encabezado para tus eventos..."
                  accepted-file-types="image/jpeg, image/png"
                />
              </v-card-text>
              <v-card-actions class="pt-0">
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                <v-btn color="blue darken-1" text @click="processFile()">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        
        <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->

        <v-row justify="center" class="my-3 mt-10">
          <v-col cols="12" class="py-0 text-center">
            <v-avatar :size="($vuetify.breakpoint.xsOnly)?200:($vuetify.breakpoint.smOnly)?200:140">
              <img :src="user.profilePicture" alt="avatar" />
              <v-dialog v-model="profileDialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-btn absolute fab top left color="accent" small v-on="on">
                    <v-icon small>fas fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Imagen de fondo</span>
                  </v-card-title>
                  <v-card-text class="pb-0">
                    <file-pond
                      name="event-img"
                      ref="pondProfile"
                      label-idle="Agrega una imagen de perfil..."
                      accepted-file-types="image/jpeg, image/png"
                    />
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="profileDialog = false">Cerrar</v-btn>
                    <v-btn color="blue darken-1" text @click="processImgOrganizer()">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-avatar>
          </v-col>
          <v-col cols="12" class="py-0 text-center">
            <h1 class="display-2 font-weight-bold">{{ user.companyName}}</h1>
          </v-col>
        </v-row>
        <v-row justify="center" class="organizer-content">
          <v-col cols="12" md="11" lg="10" class="elevation-2 pa-5">
            <v-row justify="space-around">
              <v-col cols="12" md="7" class="text-center text-md-left pb-0">
                <span class="headline font-weight-bold mr-5">Organizadores</span>
                <v-btn color="accent" class="black--text font-weight-bold" @click="downloadCsv()">
                  Reporte<v-icon right>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="5" class="pt-0">
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                      class="mr-0 mr-md-5 pt-0"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="accent" class="black--text font-weight-bold" @click="reloadTable()" v-on="on" fab small>
                          <v-icon class="black--text font-weight-bold">mdi-cached</v-icon>
                        </v-btn>
                      </template>
                      <span>Actualizar lista de organizaciones</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>


            <v-data-table
              :headers="headers"
              :items="organizations"
              :search="search"
              loading-text="Cargando datos..."
              no-data-text="No hay datos disponibles."
              no-results-text="No hay datos disponibles."
              :header-props="{
                sortByText:'Ordenar por'
              }"
              :footer-props="{
                itemsPerPageText: 'Filas por página',
                itemsPerPageAllText:'Todas',
              }"
            >
              <template v-slot:body="{items}">
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="index"
                    class="text-center"
                    :class="[(item.checkedIn===true)?'attended-color':'', ($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
                  >
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[0].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.companyName}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[1].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.name}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[2].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.lastName}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[3].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.rfc}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[4].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.razonSocial}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[5].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.bank}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[6].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.clabe}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[7].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.billEmail}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[8].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.email}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[9].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.tel?item.tel:'N/D' }}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[10].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.role=='ORGANIZER'?'Organizador':(item.role=='LITE_ORGANIZER'?'Organizador lite':'Afiliado') }}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[11].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.createdAt.substr(0,10) }}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[12].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >
                        <v-chip
                          class="pointer"
                          color="accent"
                          dark
                          @click.native.stop="selectOrganization(item)"
                        >Editar</v-chip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
            <v-dialog v-model="editOrganizerDialog" max-width="600px">
              <v-card>
                <v-row justify="space-between" class="mx-0 px-0 pt-3">
                  <v-col cols="12">
                    <p class="display-1 font-weight-bold text-left pl-2 ma-0">Editar organización</p>
                  </v-col>
                </v-row>
                <v-divider class="pt-3"></v-divider>
                <!--<v-row class="ma-0">
                  <v-col cols="12" class="px-5">
                    <p><strong>Nombre:</strong> {{sendTicketItem.name}}</p>
                    <p><strong>Apellidos:</strong> {{sendTicketItem.lastName}}</p>
                    <p><strong>Boleto:</strong> {{sendTicketItem.productName}}</p>
                    <p><strong>Fecha de compra:</strong> {{sendTicketItem.date}}</p>
                    <p><strong>Comprador:</strong> {{sendTicketItem.buyer}}</p>
                  </v-col>
                  <v-col cols="12" class="px-5 d-flex">
                    <v-text-field
                      v-model="sendTicketItem.email"
                      :rules="emailRules"
                      label="E-mail que recibirá el boleto / acceso"
                      required
                      prepend-icon="fas fa-envelope"
                    ></v-text-field>
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                      </template>
                      <span>En algunas ocasiones por la configuración de seguridad del asistente, los correos entran a la carpeta de SPAM. No te preocupes, aquí puedes enviar de nuevo cualquier boleto / acceso.</span>
                    </v-tooltip>
                  </v-col>
                </v-row>-->
                <v-row class="ma-0">
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.companyName"
                      label="Nombre de organización"
                      required
                      prepend-icon="fas fa-city"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.name"
                      label="Nombre(s) del titular"
                      required
                      prepend-icon="fas fa-user"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.lastName"
                      label="Apellidos del titular"
                      required
                      prepend-icon="fas fa-user"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.email"
                      label="E-mail de organización"
                      required
                      prepend-icon="fas fa-envelope"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.tel"
                      label="Teléfono"
                      required
                      prepend-icon="fas fa-phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.role"
                      label="Rol"
                      disabled
                      prepend-icon="fas fa-user"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.rfc"
                      label="RFC"
                      prepend-icon="fas fa-id-card"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.razonSocial"
                      label="Razón social"
                      prepend-icon="fas fa-file-contract"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.bank"
                      label="Banco"
                      prepend-icon="fas fa-university"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.clabe"
                      label="CLABE"
                      prepend-icon="fas fa-credit-card"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-text-field
                      v-model="organizationSelected.billEmail"
                      label="Email que recibe facturas"
                      prepend-icon="fas fa-credit-card"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="px-5">
                    <v-select
                      v-model="organizationSelected.validationStatus"
                      :items="statusItems"
                      item-text="item"
                      item-value="value"
                      label="Validación de organización"
                      prepend-icon="fas fa-check"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions class="px-7 pb-4">
                  <v-row justify="space-between">
                    <v-btn color="red darken-3" @click="closeEditOrganization()" dark>Cancelar</v-btn>
                    <v-btn color="accent" @click="editOrganization( organizationSelected)">Editar</v-btn>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <!--Componentes necesarios para hacer la migración de los afiliados-->
        <v-row class="mt-10" justify="center">
          <v-col cols="12" md="11" lg="10">
            <v-text-field
              v-model="accessMigrateAffiliations"
              label="pass"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-10" justify="center" v-if="accessMigrateAffiliations == 'saul@test.com'">
          <v-col cols="12" md="11" lg="10" class="elevation-2 pa-5">
            <migration-affiliates></migration-affiliates>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
  </v-container>
</template>
<script>
import productList from "@/components/shared/products/productList";
import migrationAffiliates from '@/components/newAdmin/migrationAffiliates';
import { validations } from "@/helpers/validations.js";
import { imageHelper } from "@/helpers/imageProcessing.js";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import exportFromJSON from "export-from-json";
import * as Vibrant from "node-vibrant";

// Plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Filepond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

//VueFilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  components: {
    productList,
    FilePond,
    migrationAffiliates
  },
  data() {
    return {
      loading: true,
      dialog: false,
      profileDialog: false,
      editOrganizerDialog: false,
      organizationSelected: {
        id: "",
        companyName: "",
        name: "",
        lastName: "",
        email: "",
        tel: "",
        role: "",
        rfc: "",
        razonSocial: "",
        bank: "",
        clabe: "",
        billEmail: "",
        validationStatus: "",
        createdAt: ""
      },
      defaultOrganizer: {
        id: "",
        companyName: "",
        name: "",
        lastName: "",
        email: "",
        tel: "",
        role: "",
        rfc: "",
        razonSocial: "",
        bank: "",
        clabe: "",
        billEmail: "",
        validationStatus: "",
        createdAt: ""
      },
      statusItems: [
        { item: "Validado",
          value: "VALIDATED"
        },
        { item: "En proceso",
          value: "IN_PROCESS"
        },
        { item: "Sin validar",
          value: "NOT_VALIDATED"
        },
        { item: "Rechazado",
          value: "REJECTED"
        },
      ],
      search: "",
      message: "",
      organizer: {
        imgBackground: ""
      },
      organizerBackground: "",
      items: [],
      headers: [
        { align: "center", text: "Empresa", value: "companyName" },
        { align: "center", text: "Nombre", value: "name" },
        { align: "center", text: "Apellidos", value: "lastName" },
        { align: "center", text: "RFC", value: "rfc" },
        { align: "center", text: "Razón Social", value: "razonSocial" },
        { align: "center", text: "Banco", value: "bank" },
        { align: "center", text: "CLABE", value: "clabe" },
        { align: "center", text: "Email factura", value: "billEmail" },
        { align: "center", text: "Email", value: "email" },
        { align: "center", text: "Teléfono", value: "tel" },
        { align: "center", text: "Rol", value: "role"},
        { align: "center", text: "Fecha de creación", value: "createdAt"},
        { align: "center", text: "Acciones", value: "action"}
        //{ align: "center", text: "Acciones", value: "action", sortable: false }
      ],
      accessMigrateAffiliations: ""
    };
  },
  methods: {
    ...mapMutations("event", ["setFilter"]),
    ...mapActions("event", ["fetchUserEvents"]),
    ...mapActions("user", ["fetchOrganizations", "updateUser", "updateDataOrganization"]),
    ...mapMutations("notifications", ["show"]),
    handleFilePondInit: function() {},
    async downloadCsv() {
      const fileName = 'Lista de organizadores';
      const exportType = "csv";
      let data = await this.getOrganizations();
      data.sort(function(a, b) {
        if (a.companyName.toLowerCase() > b.companyName.toLowerCase()) {
          return 1;
        }
        if (a.companyName.toLowerCase() < b.companyName.toLowerCase()) {
          return -1;
        }
        return 0;
      });
      exportFromJSON({ data, fileName, exportType });
    },
    getOrganizations() {
      let items = [];
      this.organizations.forEach(async organization => {
        //organization.role = organization.role == 'ORGANIZER'?'Organizador':'Organizador Lite';
        organization.role = organization.role=='ORGANIZER'?'Organizador':(organization.role=='LITE_ORGANIZER'?'Organizador lite':'Afiliado')
        organization.createdAt = organization.createdAt.substr(0,10);
        if(!organization.companyName){
          organization.companyName = 'N/D';
        }
        delete organization.__typename;
        await items.push(organization);
      });
      return items;
    },
    async processFile() {
      const file = this.$refs.pondHeader.getFiles()[0].file;
      this.show({ text: "Estamos guardando la imagen... 📷" });
      this.user.imgBackground = await imageHelper.resizeImg(file, 1500, 600);
      await this.updateOrganizerPicture();
      this.show({ text: "¡Encabezado actualizado con éxito!" });
      this.dialog = false;
      this.$refs.pondHeader.removeFiles();
    },
    async processImgOrganizer() {
      const file = this.$refs.pondProfile.getFiles()[0].file;
      this.show({ text:"Estamos guardando la imagen... 📷"});
      this.user.profilePicture = await imageHelper.resizeImg(file, 600, 600);
      await this.updateProfilePicture();
      this.profileDialog = false;
      this.$refs.pondProfile.removeFiles();
    },
    async updateOrganizerPicture(){
      this.user.imgBackground = await imageHelper.saveImage(this.user.imgBackground);
      this.updateUser(this.user);
      this.show({ text:"Imagen de perfíl actualizada con éxito !"});
    },
    async updateProfilePicture(){
      this.user.profilePicture = await imageHelper.saveImage(this.user.profilePicture);
      this.updateUser(this.user);
      this.show({ text:"Imagen de perfíl actualizada con éxito !"});
    },
    async getOrganizerBackground() {
      let newImg = `${this.user.profilePicture}?q=${Date.now()}`;
      let { LightVibrant, DarkVibrant } = await Vibrant.from(newImg)
        .maxColorCount(2)
        .getPalette();
      this.organizerBackground = `background-image: linear-gradient(315deg, ${LightVibrant.hex} 0%, ${DarkVibrant.hex} 74%);`;
    },
    onCopy: function(e) {
      this.show({
        text: "¡Se ha copiado la url de los eventos al portapapeles! 😄"
      });
    },
    onError: function(e) {
      this.show({ text: "¡Hubo un problema al copiar la url de los eventos!" });
    },
    async reloadTable() {
      await this.fetchOrganizations();
    },
    selectOrganization(item) {
      this.editOrganizerDialog = true;
      this.organizationSelected = Object.assign({}, item);
      if (!this.organizationSelected.validationStatus) {
        this.organizationSelected.validationStatus = "NOT_VALIDATED";
      }
    },
    closeEditOrganization() {
      this.editOrganizerDialog = false;
      this.organizationSelected = Object.assign({}, this.defaultOrganizer);
    },
    async editOrganization(organization) {
      await this.updateDataOrganization(organization);
      await this.fetchOrganizations();
      this.show({
        text: "¡Se ha se han actualizado los datos de la organización correctamente! 😄"
      });
      this.editOrganizerDialog = false;
    }
  },
  computed: {
    ...mapGetters("event", ["filteredEvents"]),
    ...mapState("user", ["user", "organizations"]),
    category_filter: {
      get() {
        return "";
      },
      set(value) {
        this.setFilter({
          filter: "category",
          value: value
        });
      }
    },
    subcategory_filter: {
      get() {
        return "Todos";
      },
      set(value) {
        this.setFilter({
          filter: "subcategory",
          value: value
        });
      }
    },
    modality_filter: {
      get() {
        return "Todas";
      },
      set(value) {
        this.setFilter({
          filter: "modality",
          value: value
        });
      }
    }
  },
  async mounted() {
    await this.getOrganizerBackground();
    await this.fetchUserEvents();
    this.loading = false;
    this.message = `https://v2.wechamber.mx/eventos-organizador/${this.user.id}`;
    await this.fetchOrganizations();
  },
  destroyed() {
    this.category_filter = "";
    this.modality_filter = "Todas";
    this.subcategory_filter = "Todos";
  }
};
</script>
<style scoped>
@media (max-width: 959px) {
  .v-btn-toggle {
    flex-direction: column !important;
  }
}

.banner-img {
  height: 65vh;
  width: auto;
  flex: none;
}
.banner-container {
  height: 65vh;
  width: 100%;
  position: relative;
}
.banner-content {
  position: absolute;
  height: 500px;
  bottom: -250px;
  transition: 0.13s all ease-in-out;
}

@media (max-width: 599px) {
  .banner-img {
    height: auto;
    width: auto;
    flex: none;
  }
  .banner-container {
    height: 200px;
    position: relative;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: 0px;
    transition: 0.13s all ease-in-out;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .banner-img,
  .banner-container {
    height: 300px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .sponsor-img {
    max-height: 85px;
    max-width: 110px;
  }
  .banner-img,
  .banner-container {
    height: 400px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}
@media (min-width: 1264px) and (max-width: 1599px) {
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 400px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }

}
@media (min-width: 1599px) and (max-width: 1903px) {
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 500px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}
@media (min-width: 1904px) {
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 400px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 230px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}
</style>
